import { Reveal, Eyebrow } from "@/components/Reveal";
import { DOCTORS } from "@/data/clinic";

const DoctorCard = ({ doc, index }) => (
  <Reveal delay={index * 0.12} className="h-full">
    <article
      data-testid={`dentist-card-${index + 1}`}
      className="group flex h-full items-center gap-5 rounded-2xl border border-[#063A2F]/10 bg-white p-6 shadow-[0_8px_30px_rgba(6,58,47,0.06)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-lg"
    >
      {doc.photo ? (
        <img
          src={doc.photo}
          alt={doc.name}
          loading="lazy"
          decoding="async"
          className="h-28 w-28 shrink-0 rounded-full object-cover object-top ring-2 ring-[#D4AF37]/40"
        />
      ) : (
        <span className="grid h-20 w-20 shrink-0 place-items-center rounded-full bg-[#E9F5EF] ring-2 ring-[#D4AF37]/40">
          <span className="font-display text-2xl font-semibold text-[#0F574E]/60">
            {doc.initials}
          </span>
        </span>
      )}
      <div>
        <h3 className="font-display text-2xl font-semibold tracking-tight text-[#063A2F]">
          {doc.name}
        </h3>
        <p className="mt-1 text-sm font-semibold text-[#0D9488]">{doc.role}</p>
        <p className="mt-0.5 text-sm text-slate-500">{doc.detail}</p>
      </div>
    </article>
  </Reveal>
);

export const Dentists = () => (
  <section id="dentists" data-testid="dentists-section" className="bg-[#F2FBF7] py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal className="max-w-2xl">
        <Eyebrow>Our Dentists</Eyebrow>
        <h2 className="font-display mt-5 text-4xl tracking-tight text-[#063A2F] sm:text-5xl">
          Meet the team behind <span className="italic text-[#0D9488]">your smile</span>
        </h2>
        <p className="mt-5 text-base leading-relaxed text-[#475569]">
          A small, dedicated team of dental surgeons caring for families across
          Bahadurpura and greater Hyderabad.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {DOCTORS.map((doc, i) => (
          <DoctorCard key={doc.name} doc={doc} index={i} />
        ))}
      </div>
    </div>
  </section>
);
